import { PLAN_KEY } from '../../constants'
import getOriginalParentIdPlanUtil from '../get-original-parent-id'
import getParentIdPlanUtil from '../get-parent-id'

import isRecommendedPlanUtil from '../is-recommended'
import { getIdReduxUtil, getValueReduxUtil, isTemporaryIdReduxUtil } from '../../../../redux'
import { MEDIA_LAYOUT_TYPE, MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX } from '../../../../images'

function getImageUriPlanUtil (plan, layoutType) {
  if (!plan) {
    return
  }
  const image = getValueReduxUtil(plan, PLAN_KEY.IMAGE)
  if (!image) {
    return
  }

  // Get the parent image workout if available
  let id
  if (isRecommendedPlanUtil(plan)) {
    id = getIdReduxUtil(plan)
  } else {
    id = (
      getOriginalParentIdPlanUtil(plan) ||
      getParentIdPlanUtil(plan) ||
      getIdReduxUtil(plan)
    )
  }

  if (isTemporaryIdReduxUtil(id)) {
    return
  }
  const imageSuffix = (
    MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX[layoutType] ||
    MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX[MEDIA_LAYOUT_TYPE.ROW]
  )
  return `plans/${id}/${image.replace('.', `-${imageSuffix}.`)}`
}

export default getImageUriPlanUtil
